import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION } from "../../common/app_constant";
import { actionInformationCard, resetInformationCradResponse } from "../../common/store";
import Slider from 'react-slick'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'


const InfromationCard = (props) => {

    const navigation = useNavigate();

    const dispatch = useDispatch()



    const { informationCard } = useSelector((state) => ({
        ...state.commonStore
    }))
    const [informationCardArr, setIformationCard] = useState([])

    const [sliderRef, setSliderRef] = useState(null)

    useEffect(() => {
        dispatch(actionInformationCard())
    }, [])


    const sliderSettings = {
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    }

    useEffect(() => {
        if (informationCard !== null) {
            dispatch(resetInformationCradResponse())
            if (informationCard.result === true) {
                setIformationCard(informationCard.data.information_card)
            } else {
                switch (informationCard.status) {
                    case 400:
                        toast.error(informationCard.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [informationCard])


    const renderData = () => {
        var arrData = []
        informationCardArr != null && informationCardArr.length ?
            informationCardArr.map((item, index) => {
                arrData.push(
                    <div class={`${props.isMarginTop === true ? 'mt-3' : ''}`}>
                        <div class="newsletter_container">
                            <div class="carousel-inner ">
                                <div class="carousel-item active">
                                    <div class=" card newsletter-container-card shadow mt-2 py-3  text-center ">
                                        <h5>{item.title}</h5>
                                        <div>
                                            {item.content}
                                        </div>
                                        {
                                            item.button_display === 1 ?
                                                <div>
                                                    <button class="btn mt-3 mb-5 px-3 newsletter-container-card-button"
                                                        onClick={() => {
                                                            window.open(item.action_link, '_blank')

                                                        }}
                                                    >View</button>
                                                </div>
                                                :
                                                <></>
                                        }

                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>
                )

            })
            :
            <></>
        return arrData
    }

    return (
        <>
            <Slider autoplay={100} ref={setSliderRef} {...sliderSettings}>
                {renderData()}
            </Slider>
            {/* <div class="mt-3">
                <div class="newsletter_container">
                    <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
                        <div class="carousel-indicators">
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0"
                                class="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"
                                aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2"
                                aria-label="Slide 3"></button>
                        </div>
                        <div class="carousel-inner ">
                            {
                                informationCardArr != null && informationCardArr.length > 0 ?
                                    informationCardArr.map((item, index) => {
                                        return (
                                            <div class="carousel-item active">
                                                <div class=" card newsletter-container-card shadow mt-2 py-3  text-center ">
                                                    <h5>{item.title}</h5>
                                                    <div>
                                                        {item.content}
                                                    </div>
                                                    {
                                                        item.button_display === 1 ?
                                                            <div>
                                                                <button class="btn mt-3 mb-5 px-3 newsletter-container-card-button"
                                                                    onClick={() => {
                                                                        window.open(item.action_link, '_blank')

                                                                    }}
                                                                >View</button>
                                                            </div>
                                                            :
                                                            <></>
                                                    }

                                                </div>
                                            </div>

                                        )
                                    })
                                    :
                                    <></>
                            }
                        </div>

                    </div>
                </div>
            </div> */}
        </>
    )
}

export default InfromationCard;